<template>
    <div v-if="template.template_context === 'order-placed-request-order-confirmation'">
        <div data-validation-target="orderConfForm">
            <v-select
                label="Order Confirmation Form"
                :items="order_confirmation_form_choices"
                :value="template.order_confirmation_settings_id"
                hint="Associate this message with an Order Confirmation form"
                :disabled="read_only || order_confirmation_form_choices.length === 0"
                persistent-hint
                clearable
                @input="onUpdateOrderConfirmationSettingsId"
            >
                <template #append-outer>
                    <v-tooltip v-if="template.order_confirmation_settings_id" bottom>
                        <template #activator="{ on, attrs }">
                            <v-btn
                                :disabled="read_only"
                                v-bind="attrs"
                                v-on="on"
                                aria-label="View selected order confirmation form"
                                icon
                                small
                                @click="onClickViewOrderConfirmationForm"
                            >
                                <v-icon aria-hidden="true" color="primary">mdi-eye</v-icon>
                            </v-btn>
                        </template>
                        <span>View Selected Order Confirmation Form</span>
                    </v-tooltip>
                </template>
            </v-select>
        </div>

        <div class="mb-8">
            <v-alert
                v-if="order_confirmation_form_choices.length === 0"
                border="left"
                colored-border
                color="primary"
                type="info"
                elevation="1"
                class="mt-2"
                dense
            >
                <div class="d-flex align-center">
                    <div class="flex-grow-1">
                        <span class="text-body-2">
                            No Published Order Confirmation forms found. Create one to associate it with this message.
                        </span>
                    </div>
                    <div class="ml-3">
                        <v-btn
                            color="primary"
                            outlined
                            small
                            @click="onClickCreateOrderConfirmationForm"
                        >
                            <v-icon aria-hidden="true" left small>mdi-plus</v-icon>
                            Create Order Confirmation Form
                        </v-btn>
                    </div>
                </div>
            </v-alert>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        template: {
            type: Object,
            required: true
        },
        order_confirmation_form_choices: {
            type: Array,
            default: () => []
        },
        read_only: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        onUpdateOrderConfirmationSettingsId(value) {
            this.$emit('update:orderConfirmationSettingsId', value);
        },

        onClickViewOrderConfirmationForm() {
            this.$emit('view-form');
        },

        onClickCreateOrderConfirmationForm() {
            this.$emit('create-form');
        }
    }
}
</script>
